
<b-container fluid class="no-gutters navMargin">
    <b-row class="d-block">
        <b-tabs v-model="tabIndex" class="navbar-dark" content-class="">
            <b-tab
                title="Förkortningar"
                :title-item-class="'tab-title-class'"
                active
                href="#abbs"
                class="m-3"
            >
                <Abbreviations
                    @commend="increment()"
                    @decommend="decrement()"
                />
            </b-tab>
            <b-tab
                lazy
                title="Manuskript"
                :title-item-class="'tab-title-class'"
                href="#manuscript"
                class="manuscriptTab"
            >
                <Manuscript />
            </b-tab>
            <b-tab
                lazy
                title="Textinställningar"
                :title-items-class="'tab-title-class'"
                href="#text"
                class="m-3"
            >
                <Font />
            </b-tab>
            <div v-if="!tester">
                <b-tab
                    lazy
                    title="Importera/Exportera"
                    :title-items-class="'tab-title-class'"
                    href="#text"
                    class="m-3"
                >
                    <ImportExport />
                </b-tab>
            </div>
            <b-tab
                title="Snabbkommandon"
                :title-items-class="'tab-title-class'"
                href="#hotkey"
                class="m-3"
            >
                <Hotkeys />
            </b-tab>
            <b-tab
                lazy
                v-if="admin"
                title="Admin-vy"
                :title-item-class="'tab-title-class ml-auto'"
                href="#admin"
                class="m-3"
            >
                <Admin />
            </b-tab>
            <b-tab
                :title-item-class="'tab-title-class ml-auto'"
                href="#changelog"
                class="informationTab"
            >
                <template #title>
                    Programinformation
                    <b-badge v-if="changes > 0">
                        {{ changes }}
                    </b-badge>
                </template>
                <Changelog />
            </b-tab>
            <b-tab
                v-if="!tester"
                title="Återställ inställningar"
                :title-item-class="'tab-title-class'"
                @click="resetSettings"
            />

            <b-tab
                v-if="webapp && !tester"
                title="Logga ut"
                :title-item-class="'tab-title-class'"
                @click="logout"
            />
            <b-tab
                v-if="webapp && tester"
                title="Logga ut"
                :title-item-class="'tab-title-class ml-auto'"
                @click="logout"
            />

            <b-tab
                v-if="!webapp"
                title="Logga ut"
                :title-item-class="'tab-title-class'"
                @click="logout"
            />

            <!--<b-tab title="Användaruppgifter" :titleItemsClass="'tab-title-class'" href="#user">
      <h2>Användaruppgifter</h2>
      <User />
    </b-tab>
    <b-tab title="Licens" href="#license">
      <License />
    </b-tab>
    -->
        </b-tabs>
    </b-row>
</b-container>
